import * as React from 'react';
import { GraphData } from '../types';
import Export from './Export';
import SegmentHeader from './SegmentHeader';

export interface GraphHeaderProps {
  selectedSegment?: any;
  graph: any;
  data?: GraphData[] | undefined | null;
  marketFilters: any;
  showExportOptions: boolean;
  setShowExportOptions: (value: React.SetStateAction<boolean>) => void;
}

const GraphHeader: React.FC<GraphHeaderProps> = ({
  selectedSegment,
  graph,
  data,
  showExportOptions,
  setShowExportOptions
}) => {
  const fileName = selectedSegment.replace(/[^A-Z0-9]+/gi, '_');
  return (
    <div className="relative flex justify-between items-center">
      <SegmentHeader spaceBottom={false} title={selectedSegment} />
      <Export
        graph={graph}
        data={data}
        fileName={fileName}
        showExportOptions={showExportOptions}
        setShowExportOptions={setShowExportOptions}
      />
    </div>
  );
};

export default GraphHeader;
